// extracted by mini-css-extract-plugin
export var modalFooter = "_r3-0";